module.exports = __webpack_public_path__ + "img/detalhe-number.a4bc7912.svg";